import React, { useEffect, useState } from "react"
import Select from "react-select"
import API from "../../api"
import PropTypes from "prop-types"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import { withTranslation } from "react-i18next"
import { Button, Col, Label, Row ,Spinner} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"

import DataTable from "react-data-table-component"
// Checkbox
import Checkbox from "rc-checkbox"
import "rc-checkbox/assets/index.css"
import defaultImage from '../../assets/images/Userr.png';
import { setSubmitFailed } from "redux-form"


const ModifUser = props => {
    const [loading, setLoading] = useState(false)
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [roles, setRoles] = useState([])
  const [selectRole, setSelectRole] = useState("")
  const [isChecked, setIsChecked] = useState(false)
// pagination
const [nbrTotlEl, setNbrTotlEl] = useState(0)
const [nbrEltperPage, setNbrEltperPage] = useState(5)
const [filterElement, setFilterElement] = useState("")
const [mycurrentPage, setMycurrentPage] = useState(1)
const [resetFirstPage, setResetFirstPage] = useState(false)
const [listmenu, setListmenu] = useState([])
const [id, setId] = useState("")
const [permissions, setPermissions] = useState([]);
//filteredMenus
const [filteredMenus, setFilteredMenus] = useState([]);
const [checkboxStates, setCheckboxStates] = useState([]);

const [confirmPassword, setConfirmPassword] = useState('');
const [passwordMatchError, setPasswordMatchError] = useState('');
const [confirmPasswordTouched, setConfirmPasswordTouched] = useState(false);
const [passwordsMatch, setPasswordsMatch] = useState(false);

const [image_changed, setImageChanged] = useState(false);
const [selectedImage, setSelectedImage] = useState(null);



 useEffect(async () => {
 var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    setId(id)

  const res = await API.get("role/select").then(res => {
    setRoles(res.data.Role)
  })
  console.log('id',id)

 API.post("user/get_by_id", { id }).then(resU => {

  console.log('resU',resU)

  
    setListmenu(resU.data.Users.permission);
    setName(resU.data.Users.name);
   // setPassword(resU.data.Users.password)
    setEmail(resU.data.Users.email);
    setSelectRole(resU.data.Users.role);
    setPermissions(resU.data.Users.permission)
    setSelectedImage(resU.data.Users.photo)

 
    
    setLoading(true)
  })

}, [])



useEffect(() => {
  const updatedFilteredMenus = listmenu.map(menu => {
    const filteredSubMenus = menu.sous_menu.filter(subMenu => {
      return (
        subMenu.add !== 0 ||
        subMenu.delete !== 0 ||
        subMenu.edit !== 0 ||
        subMenu.view !== 0 ||
        subMenu.imp !== 0
      );
    });

    if (filteredSubMenus.length > 0) {
      return {
        menu: menu.menu,
        menu_id: menu.menu_id,
        sous_menu: filteredSubMenus
      };
    }

    return null;
  }).filter(menu => menu !== null);

  setFilteredMenus(updatedFilteredMenus);
}, [listmenu]);
// const filteredMenus = listmenu.map(menu => {
//   const filteredSubMenus = menu.sous_menu.filter(subMenu => {
//     return Object.values(subMenu).some(listmenu => listmenu === 1);
//   });

//   if (filteredSubMenus.length > 0) {
//     return {
//       menu: menu.menu,
//       menu_id: menu.menu_id,
//       sous_menu: filteredSubMenus
//     };
//   }

//   return null; // Exclude menus with all permissions set to 0
// }).filter(menu => menu !== null);
// console.log(filteredMenus)
// const addPerm = (index, e, rowIndex, attribute,attribut) => {
//      const rowData = dataa[index].Detail[rowIndex];
//      console.log(attribute)
//      console.log(attribut)
//      console.log(rowData.props.children.props.data[0][attribut])
//      console.log(rowData.props.children.props.data[0][attribut].props.children.props.checked)
//      if(rowData.props.children.props.data[0][attribut].props.children.props.checked == false)
//      {
//       console.log("a")
//       console.log(listmenu[index].sous_menu[rowIndex])
//       // setPermissions((prevPermissions) => {
//       // const  updatedPermissions = [...prevPermissions];
//       //   if (!updatedPermissions[index]) {
//       //   updatedPermissions[index] = [];
//       //   console.log(updatedPermissions)
//       // }
//       // if (!updatedPermissions[index][rowIndex]) {
//      //   updatedPermissions[index][rowIndex] = {
//      //     sousmenu: rowData.props.children.props.data[0].id,
//      //     attribut: 1,
     
//      //   };
//      // }
//          // else{
//      //   console.log( updatedPermissions[index][rowIndex][attribute])
    
//    // }
//       // })
//      }
//      else{
//       console.log(listmenu[index].sous_menu[rowIndex])
//      }
//   // setPermissions((prevPermissions) => {
//   //   const updatedPermissions = [...prevPermissions];
//   //   const rowData = dataa[index].Detail[rowIndex];
//   //   console.log(updatedPermissions[index])
//   //   // Initialize the matrix for this index if it's not already defined
//   //   // if (!updatedPermissions[index]) {
//   //   //   updatedPermissions[index] = [];
//   //   //   console.log(updatedPermissions)
//   //   // }

//   //   // Initialize the row for this rowIndex if it's not already defined
//   //   // if (!updatedPermissions[index][rowIndex]) {
//   //   //   updatedPermissions[index][rowIndex] = {
//   //   //     sousmenu: rowData.props.children.props.data[0].id,
//   //   //     add: 0,
//   //   //     delete: 0,
//   //   //     edit: 0,
//   //   //     view: 0,
//   //   //     imp: 0,
//   //   //   };
//   //   // }
//   //   // else{
//   //   //   console.log( updatedPermissions[index][rowIndex][attribute])
    
//   //   // }


    

//   //   // Update the attribute value for this combination of index and rowIndex
//   // //  updatedPermissions[index][rowIndex][attribute] = e.target.checked ? 1 : 0;
//   //   //return updatedPermissions;
//   // // console.log(updatedPermissions)
//   // });
// };

const addPerm = (index, e, rowIndex, attribute) => {
  const rowData = dataa[index].Detail[rowIndex];
  const updatedCheckboxStates = [...checkboxStates];
  const updatedFilteredMenus = [...permissions];
 /* if (!updatedFilteredMenus[index]) {
    updatedFilteredMenus[index] = {
      sous_menu: [],
    };
  }*/
/*
  if (!updatedFilteredMenus[index].sous_menu[rowIndex]) {
    updatedFilteredMenus[index].sous_menu[rowIndex] = {
      sous_menu_id: rowData.props.children.props.data[0].id,
      add: 1,
      delete: 1,
      edit: 1,
      view: 1,
      imp: 1,
    };
  }*/
  updatedFilteredMenus[index].sous_menu[rowIndex][attribute] = e.target.checked ? 1 : 0;
  if (!updatedCheckboxStates[index]) {
    updatedCheckboxStates[index] = [];
  }
  updatedCheckboxStates[index][rowIndex] = e.target.checked;

  setCheckboxStates(updatedCheckboxStates);
  setFilteredMenus(updatedFilteredMenus);
  setPermissions(updatedFilteredMenus); 
};




// const addPerm = (index, e, rowIndex, attribute,attribut) => {
  
//    // const updatedPermissions = [...prevPermissions];
//     const rowData = dataa[index].Detail[rowIndex];
// console.log(rowData.props.children.props.data[0][attribut].props.children.props.checked)
// console.log(filteredMenus[index].sous_menu[rowIndex][attribute])
//  // Get the current value of the attribute in filteredMenus
//  const currentAttributeValue = filteredMenus[index].sous_menu[rowIndex][attribute];

//  // Determine the new value based on the condition you mentioned
//  let newValue;
//  if (attribut === 'ajouter' && rowData.props.children.props.data[0][attribut].props.children.props.checked) {
//   // If attribut is 'add' and its condition is true, set to 1
//   newValue = 1;
// } else if (currentAttributeValue === 1) {
//   // If current value is 1, set to 0
//   newValue = 0;
// } else {
//   // Otherwise, set to 1
//   newValue = 1;
// }
// setFilteredMenus(filteredMenus[index].sous_menu[rowIndex][attribute]=newValue)
// console.log(filteredMenus[index].sous_menu[rowIndex][attribute])
// console.log(filteredMenus)

  
// };


const expandableRowsComponent = (row) => (
  <div>
    {/* {dataa.map((el, index) => (
      // Check if row.unique_id is equal to index before rendering the div
        <div key={index}>{el.Detail}{console.log(el.Detail)}{console.log(row)}</div>
      
    ))} */}
    {row.data.Detail.map((el,i)=>(
      <div key={i}>
{el}
      </div>
    ))}
  </div>
);

const dataa = listmenu.map((menu,index) => ({
  id: menu.menu_id,
  name: menu.menu,
 Detail: menu.sous_menu.map((sousmenu, i) => (

<div key={i}>

           <DataTable
      columns={[
        { name: 'sousmenu', selector: 'sousmenu', sortable: true },
        { name: 'ajouter', selector: 'ajouter', sortable: true },
        { name: 'supprimer', selector: 'supprimer', sortable: true },
        { name: 'modifier', selector: 'modifier', sortable: true },
        { name: 'consulter', selector: 'consulter', sortable: true },
        { name: 'imprimer', selector: 'imprimer', sortable: true },

      ]}
      
      data={
       [{
     id: sousmenu.sous_menu_id,
        sousmenu: sousmenu.sous_menu,
        ajouter: (
          <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
          <Checkbox 
  //  checked={sousmenu.add === 1 ? true :isChecked}
  checked={ permissions &&  permissions[index]?.sous_menu[i]?.add === 1 }
      onChange={
        (e) => addPerm(index,e, i, 'add','ajouter')} />
          {/* {
            sousmenu.add === 1 ?
            <Checkbox 
            checked={sousmenu.add === 1 }
            onChange={(e) => {
              addPerm(index, e, i, 'add', 'ajouter');
            }}
          /> :        <Checkbox 
              checked={isChecked }
         
            onChange={(e) => {
                                  addPerm(index, e, i, 'add', 'ajouter');
           
          }}
        />
          } */}
   

          </div>
        ),
        supprimer: (
          <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
             <Checkbox 
     // checked={sousmenu.delete === 1}
     checked={ permissions && permissions[index]?.sous_menu[i]?.delete ===1 }

      onChange={(e) => addPerm(index,e, i, 'delete','supprimer')} />
          </div>
        ),
        modifier: (
          <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
           <Checkbox 
       //checked={sousmenu.edit === 1}
       checked={ permissions &&  permissions[index]?.sous_menu[i]?.edit ===1 }

      onChange={(e) => addPerm(index,e, i, 'edit','modifier')} />
          </div>
        ),
        consulter: (
          <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
            <Checkbox 
     // checked={sousmenu.view === 1}
     checked={permissions && permissions[index]?.sous_menu[i]?.view ===1 }

      onChange={(e) => addPerm(index,e, i, 'view','consulter')} />
          </div>
        ),
        imprimer: (
          <div key={i} style={{ display: 'flex', justifyContent: 'center' }}>
            <Checkbox 
      // checked={sousmenu.imp === 1}
      checked={permissions && permissions[index]?.sous_menu[i]?.imp ===1 }

      onChange={(e) => addPerm(index,e, i, 'imp','imprimer')} />
          </div>
        )
       }] 
        
    }
      noHeader
     
    //  expandableRowsComponent={YourComponent}
    />
</div>
  )),
}));

const renderChildRow = (row) => {
  return (
    <div>
      <p>Name: {row.name}</p>
      <p>Age: {row.age}</p>
      <p>Country: {row.country}</p>
      {/* You can add other child row information as needed */}
    </div>
  );
};
const columns = [

  { name: 'Menu', selector: (row) => row.name },

];

////Methode update ////
/////
const edit = async () => {
  try {
    if (password === confirmPassword){
    const res = await API.post("user/edit", {
      id: id,
      name: name,
      email: email,
      password: password,
      role_id: selectRole.value,
      permissions: permissions,
      ImageChanged: image_changed,
      photo: selectedImage
    });
  

    props.history.push("/User");
  }else {
  toast.error( "Les mots de passe ne correspondent pas",{
    containerId: "A",
  });}

    //props.setSection(1);
  } catch (error) {
    if ( error.response.status === 422) {
      toast.error( error.response.data.message,{
        containerId: "A",
      });
    }
  }
};

/////

const newElement = async (page, totalRows) => {
    setMycurrentPage(page)
    const res = await API.get("menu/list")
    .then(res => {
      setListmenu(res.data.Menu)
      //setNbrTotlEl(res.data.Data[0].total)
    })
  }

  const perPage = async (currentRowsPerPage, currentPage) => {
    setMycurrentPage(currentPage)
    const res = await API.get("menu/list")
    .then(res => {
      setListmenu(res.data.Menu)
      // setNbrTotlEl(res.data.Data[0].total)
    })
  }
  useEffect(() => {
    if(confirmPassword != "" ){
    if ( password !== confirmPassword) {
      setPasswordMatchError('Les mots de passe ne correspondent pas');
      setPasswordsMatch(false);
    } else if (password === confirmPassword ) {
      setPasswordMatchError('Les mots de passe correspondent');
      setPasswordsMatch(true);

    }}
    else {
      setPasswordMatchError('');

    }
  }, [password, confirmPassword]);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
    setConfirmPasswordTouched(true);
  };

  const handleImageUpload = (event) => {
    setImageChanged(true)
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = function (e) {

      setSelectedImage(e.target.result);

    };

    reader.readAsDataURL(file);
  };



  return (
     <React.Fragment>
      <div className="page-content card" >
      {loading ? (

        <Row>
          <div className="ms-2" style={{ width: "20rem" }}>
          <img
            id="selectedImage1"
            src={selectedImage ? (image_changed === false ? `data:image/png;base64, ${selectedImage}` : selectedImage) : defaultImage}
            className="avatar-s rounded-circle img-thumbnail"
            style={{ width: "11rem", height: "11rem", }}
          />
          <div className="col-md-6 btn btn-danger btn-rounded " >
            <label className="form-label text-white m-1" htmlFor="customFile1"> Photo de profil</label>
            <input type="file" name="logo_image" className="form-control d-none" id="customFile1" onChange={handleImageUpload} />
          </div>
        </div>
          <AvForm>
            <Row>

              <Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-firstname-input1">Nom</Label>
                  <AvField
                    name="nom"
                    placeholder="Inserer un nom"
                    type="text"
                    errorMessage="* Nom obligatoire"
                    className="form-control"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    validate={{ required: { value: true } }}
                  />
                </div>
              </Col>
              <Col lg="6">
                <Label for="basicpill-firstname-input1">Email</Label>
                <AvField
                  name="email"
                  value={email}
                  placeholder="Enter un email valide"
                  type="email"
                  onChange={e => setEmail(e.target.value)}
                  errorMessage="* Email invalide"
                  validate={{
                    required: { value: true },
                    email: { value: true },
                  }}
                />
              </Col>
            </Row>
            <Row>
            <Col lg="6">
            <div className="mb-3">
                  <Label for="basicpill-address-input1">Rôle</Label>
                  <Select
                    value={selectRole}
                    options={roles}
                    isSearchable={true}
                    classNamePrefix="select2-selection"
                    onChange={e=>setSelectRole(e)}
                  />
                </div>
                
              </Col>
              <Col lg="6">
                <Label for="basicpill-firstname-input1">Nouveau mot de passe</Label>
                <AvField
                  name="password"
                  type="password" 

                  placeholder="Inserer un mot de passe "
                  onChange={handlePasswordChange}
                />
              </Col>
              <Col lg="6"></Col>

              <Col lg="6">
                <Label for="basicpill-firstname-input1">Confirmer nouveau mot de passe</Label>
                <AvField
                  name="password"
                  type="password"

                  placeholder="Inserer un mot de passe "
                  onChange={handleConfirmPasswordChange}
                />
                 {passwordMatchError && passwordsMatch=== false && <span style={{ color: 'red' }}>{passwordMatchError}</span>}
                {passwordMatchError && passwordsMatch=== true && <span style={{ color: 'green' }}>{passwordMatchError}</span>}
              </Col>
              {/*<Col lg="6">
                <div className="mb-3">
                  <Label for="basicpill-address-input1">Rôle</Label>
                  <Select
                  value={selectRole}
                    options={roles}
                    isSearchable={true}
                    classNamePrefix="select2-selection"
                    onChange={setSelectRole}
                  />
                </div>
                </Col>*/}
            </Row>
    {/* datatable permissions */}
  <div style={{ display: "flex", justifyContent: "center" }}>
              {" "}
              <Col lg="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                  className="text-center mt-4"
                >
                  <Button
                    type="button"
                    color="warning"
                    className="btn btn-warning  mb-2 me-2"
                    // onClick={props.back}
                    onClick={() => props.history.push("/User")}
                  >
                    {props.t("Annuler")}
                  </Button>
                </div>
              </Col>
              <Col lg="6">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                  className="text-center mt-4"
                >
                  <button
                    onClick={edit}
                    type="submit"
                    className="btn btn-primary "
                  >
                    Confirmer
                  </button>
                </div>
              </Col>
            </div>
          </AvForm>
        
       

        </Row>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {" "}
            <Spinner type="grow" className="ms-6" color="primary" />
          </div>
          <h4
            style={{ textAlign: "center", marginTop: "2%" }}
            className="ms-6"
          >
            {" "}
            {props.t("Chargement en cours...")}
          </h4>
        </div>
      )}
      </div>
   
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(ModifUser)
ModifUser.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}